/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Security_LogsInputs */

const en_audit_security_logs = /** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & Audit Logs`)
};

const es_audit_security_logs = /** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros de Auditoría y Seguridad`)
};

const fr_audit_security_logs = /** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journaux de sécurité et d'audit`)
};

const de_audit_security_logs = /** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheits- & Audit-Protokolle`)
};

const id_audit_security_logs = /** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log Keamanan & Audit`)
};

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const ja_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const zh_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const ar_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const it_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const ru_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const pt_audit_security_logs = en_audit_security_logs;

/** @type {(inputs: Audit_Security_LogsInputs) => LocalizedString} */
const ko_audit_security_logs = en_audit_security_logs;

/**
* | output |
* | --- |
* | "Security & Audit Logs" |
*
* @param {Audit_Security_LogsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const audit_security_logs = /** @type {((inputs?: Audit_Security_LogsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Security_LogsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_security_logs(inputs)
	if (locale === "es") return es_audit_security_logs(inputs)
	if (locale === "fr") return fr_audit_security_logs(inputs)
	if (locale === "de") return de_audit_security_logs(inputs)
	if (locale === "ja") return ja_audit_security_logs(inputs)
	if (locale === "zh") return zh_audit_security_logs(inputs)
	if (locale === "ar") return ar_audit_security_logs(inputs)
	if (locale === "id") return id_audit_security_logs(inputs)
	if (locale === "it") return it_audit_security_logs(inputs)
	if (locale === "ru") return ru_audit_security_logs(inputs)
	if (locale === "pt") return pt_audit_security_logs(inputs)
	return ko_audit_security_logs(inputs)
});